// @ts-check
import React from 'react';
import classNames from 'classnames';
import AccordionSection from './AccordionSection';

import './Accordion.scss';

/** @type {import('~/types/React').ReactFC} */
const Accordion = ({ children, ...rest }) => {
	/** @type {Record<number, boolean>} */
	const initial = {};
	const [openMap, setOpenMap] = React.useState(initial);

	const toggleById = (id) => setOpenMap((prev) => Object.assign({}, prev, { [id]: !prev[id] }));

	return (
		<div {...rest} className={classNames(rest.className, 'accordion')}>
			{/* @ts-ignore - Legacy config or Accordions. */}
			{children.map((child, i) => (
				<AccordionSection
					className={child.props.className}
					key={i}
					isOpen={!!openMap[i]}
					label={child.props.title}
					onClick={() => toggleById(i)}
				>
					{child.props.children}
				</AccordionSection>
			))}
		</div>
	);
};
export default Accordion;
